export enum SigningRequestChannel {
  None = 'none',
  Email = 'email',
  SMS = 'sms',
}
